import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ButtonIcon,
  FormHeader,
  InputBox,
  OtpResendTimer,
  SectionHeader,
} from "../../../components";
import {
  closeEmailVerificationModal,
  openEmailChangeModal,
  openSubscriber,
  setAdsUserDetails,
} from "../../AdsPlatform/redux/actions";
import {
  CheckValidity,
  newsUserDetails,
  setAdsSession,
  setUserSession,
} from "../../../utils";
import { notification } from "antd";
import {
  resendEmailVerification,
  verifyEmail,
} from "../../AdsSignUp/services/adsSignup.service";
import { setNewsUser } from "../../console/redux/actions";

const Index = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [displayOtpResend, setDisplayOtpResend] = useState(true);

  const [formData, setFormData] = React.useState({
    otp: {
      key: "otp",
      label: "",
      size: "lg",
      isOTP: true,
      elementConfig: {
        type: "text",
        placeholder: "000000",
        maxLength: 6,
      },
      validation: {
        required: true,
        number: true,
      },
      touched: false,
      isValid: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
  });

  const { signupUser, signupUserToken, isOpenEmailVerificationModal } =
    useSelector(({ adsUserReducer }) => adsUserReducer);

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateContactForm = {
      ...formData,
    };

    updateContactForm[inputIdentity].value = event;

    let validityRes = await CheckValidity(
      inputIdentity,
      updateContactForm[inputIdentity].value,
      updateContactForm[inputIdentity].validation
    );
    if (validityRes) {
      updateContactForm[inputIdentity].isValid = validityRes.isValid;
      updateContactForm[inputIdentity].invalidReason = validityRes.reason;
      updateContactForm[inputIdentity].touched = true;

      // updateContactForm[inputIdentity] = updatedFormElement;
      let formIsValid = false;
      for (let inputIdentifier in updateContactForm) {
        formIsValid = updateContactForm[inputIdentifier].valid && formIsValid;
      }

      setFormData(updateContactForm);
    }
  };

  const onClickResendEmailVerification = async () => {
    setIsLoading(true);
    setDisplayOtpResend(false);
    setIsDisable(true);
    try {
      let newsUser = newsUserDetails();
      let user = signupUser || newsUser;

      if (user) {
        let resVerify = await resendEmailVerification({
          company_id: user?.company_id,
          email: user?.working_email,
        });
        if (resVerify.data.status) {
          console.log("resVerify", resVerify.data);
          setAdsSession(resVerify.data?.data?.token);
          setIsLoading(false);
        } else {
          notification.error({
            message: "Error",
            description: resVerify.data.message,
          });
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error resending email verification:", error);
      setIsLoading(false);
      notification.error({
        message: "Error",
        description: "Failed to resend verification email. Please try again.",
      });
    }
  };

  const verifyEmailOtp = async () => {
    const updateForm = { ...formData };
    try {
      setIsLoading(true);
      if (updateForm.otp.value?.length < 4) {
        notification.error({
          message: "Error",
          description: "Please enter correct OTP",
        });
        return;
      }
      let body = {
        token: signupUserToken,
        otp: updateForm.otp.value,
        company_id: signupUser?.company_id,
      };
      let res = await verifyEmail(body);
      console.log(res);
      if (res?.data?.status) {
        setIsLoading(false);
        console.log("res", res.data.data);
        setAdsSession(res?.data?.token);
        dispatch(setAdsUserDetails(res.data.data?.user));
        dispatch(setNewsUser(res.data.data?.user));
        // if (res.data.data?.user?.company_type !== "publisher") {
        setUserSession(res.data.data?.token);
        console.log(res.data.data?.token);

        // }
        dispatch(closeEmailVerificationModal());
        dispatch(openSubscriber(true));
        // setTimeout(() => {
        //   if (res.data.data?.user?.company_type === "publisher") {
        //     props.history.push(`/ads/campaign`);
        //   } else {
        //     props.history.push(`/`);
        //   }
        // }, 6000);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log({ error });
      setIsLoading(false);
    }
  };

  const onCountdownFinish = () => {
    setIsDisable(false);
    setDisplayOtpResend(true);
  };

  // set a timer to automatically active resend button after 30 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDisable(false);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  useEffect(() => {
    let companyUser = newsUserDetails();
    if (companyUser?.company_id) {
      setUser(companyUser);
    }
  }, []);

  const fetchEmail = (value) => {
    return value.replace(
      /^[ ]*([^@\s])([^@\s]*)(@(?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i,
      (_, firstChar, rest, domain) =>
        `${firstChar}${"*".repeat(rest.length)}${domain}`
    );
  };

  const updateVerifyForm = { ...formData };

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenEmailVerificationModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper modal-container d-flex flex-column w-700 animate__animated  ${
          isOpenEmailVerificationModal
            ? "open_me animate__bounceIn"
            : "close__me"
        }`}
      >
        <div className="common-modal-close">
          <ButtonIcon
            data={{ iconName: "cross", size: "sm" }}
            onClick={() => dispatch(closeEmailVerificationModal())}
          />
        </div>
        <div className={"evm__form"}>
          <div className={"evmf__header-wrapper"}>
            <div className={"evmf__hw-logo"}>
              <img
                src={require("../../../assets/img/logo_new.png")}
                alt={"logo"}
              />
            </div>
            <FormHeader
              data={{
                formHeader: "We’ve sent a verification email to",
                size: "md-md",
              }}
            />
            <SectionHeader
              data={{
                title:
                  ((signupUser?.working_email || user?.working_email) &&
                    fetchEmail(
                      signupUser?.working_email || user?.working_email
                    )) ||
                  "your email",
                size: "md-sm",
              }}
            />
          </div>
          <div className={"evmf__re-enter"}>
            <div className={"d-flex flex-row"}>
              You can re-enter email
              {"  "}
              <span
                className={"evmf__re-here pl-1"}
                onClick={() => {
                  dispatch(openEmailChangeModal(signupUser || user));
                }}
              >
                {" "}
                here
              </span>
              , if the one you entered was incorrect
            </div>
            <span></span>
          </div>
          <div className={"evmf__content"}>
            {/* <span>Check your email!</span>
            <span>
              We’ve sent you an magic link Click the button to activate
            </span>
            <span>your account.</span> */}{" "}
            <InputBox
              data={updateVerifyForm.otp}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(e.target.value, updateVerifyForm.otp.key);
              }}
            />
          </div>
          <Button
            data={{
              btnName: "VERIFY",
              buttonType: "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              disabled: false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              await verifyEmailOtp(e);
            }}
          />
          <div className={"evmf__find"}>Still can't find the email ?</div>
          <div className={"evmf__resend timer mt-1"}>
            <OtpResendTimer
              numberOfInputs={6}
              timeInterval={20}
              displayCountdown={isDisable}
              countdownText={"Resend"}
              onCountdownFinish={onCountdownFinish}
            />
          </div>
          {!isDisable && displayOtpResend && (
            <div
              className={"evmf__resend pt-1"}
              onClick={async (e) => {
                e.preventDefault();
                await onClickResendEmailVerification(e);
              }}
            >
              RESEND
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Index;
